<ng-container *ngIf="anchors != null">
    <div *ngIf="simpleView else enhancedView" style="display:flex; flex-wrap: wrap; gap: 8px 16px; margin-top: 10px;">
      <span  *ngFor="let row of anchors; let i = index">
        <div> 
        <a (click)="viewAnchor(row)" [tooltip]="getAnchorText(row, 13)">
          <!--<i class="fa fa-anchor" aria-hidden="true" [tooltip]="st"></i>-->
          
            <div style="display: flex;">
              <anchor-icon></anchor-icon>
              <span style="font-size: small; margin-left: 3px">{{ getAnchorPath(row) || getAnchorText(row, 2) }}</span>
            </div>
        </a>
        </div>
      </span> 
    </div>
    <ng-template #enhancedView>
      <div class="anchors">
        <span  *ngFor="let row of anchors; let i = index">
          <div class="anchor-row">
            <anchor-icon></anchor-icon>
            <a *ngIf="!editingConsistencyCheckResults[row.issueId]" [title]="getAnchorText(row, 13) ?? getAnchorPath(row)" style="font-size: small; margin-left: 3px" (click)="viewAnchor(row)">{{ getAnchorPath(row) || getAnchorText(row, 2) }}</a>
            <input type="text" size=40 *ngIf="editAnchorsPaths && editingConsistencyCheckResults[row.issueId]" class="t-input anchor-input" [value]="row.embeddedObjectAnnotation.anchorPath ?? row.embeddedObjectAnnotation.startingPhrase" (blur)="onFinishedTyping($event, row)">
              <div class="anchor-actions">
                  <ng-container *ngIf="displayActions">
                  
                    <a style="margin-right: 2px" class="icon"
                    [class.disabled]="disableActions"
                    *ngIf="editAnchorsPaths"
                      (click)="editingConsistencyCheckResults[row.issueId] = !editingConsistencyCheckResults[row.issueId]">
                      <i [class.disabled]="disableActions" class="fa-solid fa-pen-to-square t-small" [title]="'translate.general.renameAnchor' | translate"></i>
                    </a>
                    <a *ngIf="!editingConsistencyCheckResults[row.issueId]" style="margin-right: 2px" class="icon"
                      [class.disabled]="disableActions" (click)="removeAnchor(row); editingConsistencyCheckResults[row.issueId] = false">
                      <i [class.disabled]="disableActions" class="fa-solid fa-xmark t-small" [title]="'translate.general.remove' | translate"></i>
                    </a>
                  </ng-container>
                <ng-container *ngIf="copyAnchors">
                  @let hasAnchorInMatchedPhrase = hasAnchor(row);
                  <a  class="icon" [class.disabled]="hasAnchorInMatchedPhrase || disableActions" (click)="copyAnchor(row)">
                    <i class="fa-regular fa-circle-left" [title]="'translate.general.copyAnchor' | translate" [class.disabled]="hasAnchorInMatchedPhrase || disableActions"></i>
                  </a>
                </ng-container>
              </div>
          </div>

        </span>
      </div>
    </ng-template>
    <ng-template #tableView>
      <div class="t-small">
          <ui-table
          [isWrapped]="true"
          [wrapperClass]="'anchors-table'"
          [data]="anchors"
          [templates]="[
              {
              title: 'translate.anchor.general',
              template: anchor
              },
              {
              title: 'translate.general.actions',
              template: actions,
              colClass: 'claim-consistencies-table-actions-column'
              }
          ]"
          ></ui-table>
      </div>
        <div style="font-style: italic; text-align: right; margin-top: 0.3em; color: #9d9fa2">
          <ai-icon></ai-icon>
        </div>
    </ng-template>
      <view-page-and-annotate-element *ngIf="showConsistencyIssuePhrases"
    [embeddedObjectAnnotation]="currEmbeddedObjectAnnotation"
    (closePdfViewerEmitter)="showConsistencyIssuePhrases = false">
  </view-page-and-annotate-element>
</ng-container>
<ng-template #anchor let-row="row">
        
    <span>{{ getAnchorPath(row) || getAnchorText(row, 13) }}</span>
</ng-template>

<ng-template #actions let-row="row">
  <a  (click)="viewAnchor(row)"><i appendTo="body" tooltipPosition="bottom" style="z-index: 999999" class="fas fa-eye icon-view" [pTooltip]="'translate.general.view' | translate" ></i></a>
  <ng-container *ngIf="enableRemoveAnchors">
    <span class="action-divider">|</span>
    <a (click)="removeAnchor(row)"><i appendTo="body" tooltipPosition="bottom" class="fa-solid fa-xmark" [pTooltip]="'translate.general.remove' | translate"></i></a>
  </ng-container>
</ng-template>